export default {
  methods: {
    getPicturePath(pictureFileName) {
      return pictureFileName && (process.env.VUE_APP_SERVER_ADDRESS + '/files/avatar/' + pictureFileName) || null
    },
    getNewsImgPath(imageName) {
      return process.env.VUE_APP_SERVER_ADDRESS + '/files/news/' + imageName
    },
    getMallLogoPath(logo) {
      return process.env.VUE_APP_SERVER_ADDRESS + '/files/malls/' + logo
    },
    getDocumentPath(id) {
      return process.env.VUE_APP_SERVER_ADDRESS + '/documents/' + id + '/download'
    }
  }
}